import { yupResolver } from '@hookform/resolvers/yup';
import { Box, Typography } from '@mui/material';
import { FunctionComponent, useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

import { AutocompleteOptions, SelectFieldWrapper } from '@Components/index';
import Loader from '@Components/Loader';
import Modal from '@Components/Modal';
import { LibraryModalProps } from '@Containers/Groups/LibraryModal/LibraryModal.types';
import LibraryTemplates from '@Containers/Groups/LIbraryTemplates';
import { useGetAllGroupsQuery } from '@Services/groups.service';

const LibraryModal: FunctionComponent<LibraryModalProps> = (
  props: LibraryModalProps
): JSX.Element => {
  const { isOpen, setIsOpen, type } = props;

  const { t } = useTranslation();
  const methods = useForm({
    resolver: yupResolver(
      yup.object({
        group: yup
          .object()
          .nullable()
          .shape({ value: yup.string(), label: yup.string() }),
      })
    ),
    mode: 'onChange',
    shouldUnregister: true,
  });
  const group: { value: string; label: string } | undefined = methods.watch(
    'group'
  ) as { value: string; label: string } | undefined;

  const [options, setOptions] = useState<AutocompleteOptions[]>([]);

  const {
    data: allGroups,
    isLoading: allGroupsIsLoading,
    isFetching: allGroupsIsFetching,
  } = useGetAllGroupsQuery();

  const loading = allGroupsIsLoading || allGroupsIsFetching;

  useEffect(() => {
    if (allGroups) {
      const tempOptions: AutocompleteOptions[] = allGroups?.map((g) => ({
        label: g.name,
        value: g.id,
      }));
      setOptions(tempOptions);
    }
  }, [allGroups]);

  return (
    <>
      <Modal
        open={isOpen}
        headerText={t('groups.Groups')}
        onClose={() => setIsOpen(false)}
      >
        <FormProvider {...methods}>
          <Box sx={{ padding: '3rem 2.4rem 2.4rem' }}>
            <Typography variant="h2">
              Each group has a pre-defined set of{' '}
              {type === 'global_scripts' ? 'scripts' : 'emails'} available for
              you to automatically add to your dialer. Please choose a group to
              browse and then select your desired{' '}
              {type === 'global_scripts' ? 'scripts' : 'emails'}.{' '}
            </Typography>
            {loading ? (
              <Loader />
            ) : (
              <>
                <Box display="flex" mt={3.8}>
                  <SelectFieldWrapper
                    name="group"
                    options={options}
                    multiple={false}
                    textFieldProps={{
                      label: `${t('common.table.Group')} *`,
                      placeholder: t('common.table.Select Group'),
                      InputProps: {
                        readOnly: false,
                      },
                    }}
                    sx={{ minWidth: '24.8rem', maxWidth: '24.8rem', mr: 5 }}
                  />
                </Box>
                <LibraryTemplates
                  groupId={group?.value}
                  type={type}
                  closeModal={() => setIsOpen(false)}
                />
              </>
            )}
          </Box>
        </FormProvider>
      </Modal>
    </>
  );
};

export default LibraryModal;
